export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list.vue?vue&type=template&id=3e88fd93&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/list.vue?vue&type=template&id=3e88fd93&scoped=true
// module id = XxCJ
// module chunks = 0